import * as React from 'react';

import * as styles from './ListingButtonWrapper.css';

export const ListingButtonWrapper: React.FC<React.PropsWithChildren> = ({ children }) => {
  return <div className={styles['wrapper']}>{children}</div>;
};
